export default {
  language: {
    name: "English",
  },
  navbar: {
    index: "DO Network",
    index1: "DO Network",
    learn: "Learn",
    technology: "Technology",
    developer: "Developer",
    community: "Community",
    join: ["Join our Autonomous", "Organization."],
    // decentralized: 'Decentralized',
    decentralized: "Decentralization",
    website: "Official website architecture.",
    copy: "COPYRIGHT© 2018-2021 DO Network FOUNDATION",
    message:
      "Please don't trust fake accounts. For more info, please follow our offical channels!",
  },
  Login: {
    Community: "Community proposal",
    what: "what is Community proposal?",
    Were: "We're an inclusve community uniting people around the world with apassion for decentralized blockchain.",
    Sign: "Sign in",
    Welcome: "Welcome to the community",
    Signup: "Sign up",
    Forget: "Forget password",
    bindWallet: "Binding the wallet",
    Email: "donetwork@outlook.com",
    Ok: "OK",
  },
  Register: {
    Sendcode: "Send code",
  },
  home: {
    // title: ['A decentralized', 'high-performance blockchain', 'network organized by DAO.'],
    title: [
      "Do Network is a ",
      "decentralized network with",
      "ultra-high performance.",
    ],
    subTitle: [
      "High-decentralized transaction processing logic",
      "Create sustainable scalability for DAO transactions.",
    ],
    Create:
      "Create the top DAO application world through the DO economic model of the permanent motion cycle.",
    Unbelievable:
      "It has achieved a scalable DPOS consensus agreement through a number of technological innovations,which we call Wave Consensus,so as to achieve more unimaginable TPS performance.",
    // Unbelievable:"Unbelievable performance and the DO economic model of the permanent motion cycle, create the top DAO application world.",
    sanTitle: [
      "499 active nodes selected by equity clients randomly handle various transactions.",
      "Process thousands of transactions per second and lift sustainable expand transaction capabilities as node performance improves.",
    ],
    decentralized: "Decentralization",
    high: "Public nodes and verifiers can join or exit freely",
    // high: ' High-decentralized transaction processing logic--- 499 active nodes selected by equity clients randomly handle various transactions.',
    sustainable: "High performance",

    Dao: "Wave Consensus realizes scalable DPOS algorithm and continuously expands the ability to process transactions on the chain",
    diversified: "Economic model",
    protocol:
      "DO can deposit and withdraw freely like a bank, and obtain your deposit interest",
    dual: "Security",
    WASM: "Multiple VRF can verify the algorithm application of random number to ensure the security of on-chain transactions",
    browser: "Browser",
    jump: "Jump to browser",
    toWallet: "The wallet guide",
    toWiki: "Jump to technology wiki",
    toStake: "Jump to technology wiki",
    partners: "Core Partners",
  },
  DAO: {
    index: "Advantages of DAO",
    title: [
      "Multiple VRF can verify the algorithm application of random number to ensure the security of on-chain transactions",
      // "and the economic model better",
      // "support the development of DAO.",
    ],
    logical: "Execute transactions on the chain with a second efficiency",
    efficiency: "Easier to participate in ecological economy",
    efficiency1: "Mechanism of free participation or withdrawal",
    fund: "Open-mode obtain DAO fund",
    call: "Easier for enterprises and organizations to call",
    call1: "Fair execution of transactions on the chain",
    technology: "Technical Advantages",
    technology1: "Advantages of DAO",
    come: "The Contract Incentive Model of Innovation",
    rewardTail:
      "Once the application contract created by the developer is used, you will get a long-term stable DO reward",
    ecoTail:
      "DO network designs an economic model from the underlying architecture that is easier for developers to develop ecologically.",
    start: "From here to create your interesting application ideas",
    start1:
      "Destroy a small DO amount to add to the application development of",
    start2:
      "You will obtain a continuous DO reward if you develop DAO applications that are used repeatedly.",
    build: "Jump to the contract technology wiki",
    build1: "Technology wiki",
    wiki: "Skip to protocol technology wiki",
    reward: "Reward mechanism",
    eco: "Long-term stable DO reward",

    org: "DAO organization",
    what: "What is DAO organization?",
    detail:
      "DAO (decentralized autonomous organization) is a business organization, control in this organization is decentralized rather than hierarchical. Besides, DAO`s use smart contracts to organize. Participants use governance tokens to vote on topics such as funds allocation. Also, DAO conducts a flatter management structure and enforces rules set automatically on the blockchain. It allows everyone to participate in discussions, encourages teamwork, and can create some pretty cool things.",
    various: "Various from",
    form1:
      "Encryption project- Considered it is a DAO if it is carried out in a decentralized manner to govern. In this governance, token holders can vote on the project direction, Maker DAO.",
    form2:
      "Grants - Can use DAOs to release development funds based on set criteria automatically,  Moloch DAO.",
    form3:
      "Investment –Moloch DAO has been used several times to create for-profit DAOs that can allocate and transfer shares and other assets among members, Meta Cartel Ventures.",
    form4:
      "Collecting - DAO in the form of collection flourishes with the prosperity of non-fungible- tokens (NFT), flamingo DAO.",
    adv: "Advantages",
    adv1: "High-transparency ---- Everyone can check voting, fundraising, and the other operations.",
    adv2: "Inspire more power ---- Members worldwide can contribute, the barrier to entry the DAO is lower than the companies.",
    adv3: "Inexpensive ---- The concept is already firmly rooted in DeFi, and there are so many tools that can be used like Lego bricks that there is little need to build from scratch.",
    adv4: "Strong collaboration ---- Let everyone have a say, gather informative proposals, and enable experts to invest in the ecosystem they established.",
    join: "Join our Organization",
    DONetwork: "DO network",
    tech: "Technical",
  },
  Learn: {
    learn: "Learning",
    Clients: "Ecology",
    introductory: "DO network Introduction",
    network: "DO network",
    tool: "DO network wallet tool",
    decentralized:
      "Decentralized Organization Network is a decentralized blockchain system with ultra-high performance. Based on the wave protocol, it can quickly complete the consensus on the chain and efficiently execute the transactions on the chain. The more participatory economic model will stimulate the rapid development of its Web3.0 ecology.",
    doWhat: "What can you do in DO network?",
    runNode:
      "Running a node--- DO Network consists of 499 independent physical nodes. The nodes are not limited to entering the network in chronological order. The clients will select all nodes triggered into the network in chronological order and stake ranking when they reach 499 complete nodes.",
    getRewards:
      "Clients---you can easer select the node you trust to get more rewards.",
    provideIdeas:
      "Developer--- Write your unique ideas into code, you will get more rewards once it gets more users.",
    participationDao:
      "Governance--- Participate in DAO transactions in the DO ecosystem and promote DAO development together.",
    run: "Running node",
    runDetail: "Vote for excellent node operators to get more rewards",
    provide: "Developers",
    provideDetail:
      "There is no need to create complex economic models for your simple applications. If more people use them, you will get continuous DO rewards",
    partici: "Client",
    particDetail:
      "You’ll participate in various affairs in DO ecology and push on the development of Do Network together.",

    overview: "DO network Summary",
    overview1: ["DO network", "Summary"],
    what: "What is DO Summary?",
    detail:
      "On the premise of not sacrificing the decentralized network, DO network has designed a more lightweight wave consensus protocol, which can enable the entire network to more efficiently execute the transactions on the chain. We have designed a more distinctive economic model on the basis of open source, and established a community-based ecological fund to promote the development and prosperity of DO for a long time.",
    consensus: "Wave consensus",
    consensusDetail:
      "Select multiple candidates through dual VRF random number algorithm to process the transactions on the chain in parallel, and finally complete the consensus after verification by different groups of verifiers randomized.",
    high: "Routing network",
    highDetail:
      "Greatly increase the number of network nodes without sacrificing communication efficiency",
    DAG: "DAG structure",
    DAGDetail:
      "Each block adopts special placement calculation rules to avoid branching on the chain",
    model: "Economic model",
    modeDetail:
      "Fair rights and interests rules and efficient exit mechanism ,which will retain the participation rights of all users",

    token: "DO Token",
    whatToken: "What is DO Token?",
    token1: "DO vesting schedule",
    detail2:
      "DO is the only token in the decentralized organization network, with a total circulation of 200,000,000, of which 35% is the circulation, 55% is used for node incentives, 5% is used for Do Labs, 5% is used for global ecological development, and is deeply integrated into the economic ecology of DO network. You can obtain it in the following ways",
    // detail2:
    //   "DO is the only token in the Decentralized Organization Network,which is deeply integrated into the economic ecology of the DO network. You can obtain it in the following ways",
    whatToken1: "What is DO vesting schedule?",
    detail21:
      "This year, we will release and complete the initial circulation and the amount will be 12,657,281 DO, Total circulation 6.32% of the circulation.",
    whatToken2: "Annual/Annualized return rate",
    way1: "Get rewards for air drop activities",
    way2: "Running nodes to obtain rewards",
    way3: "Staking for rewards",
    way4: "Reward for contribution code",
    way5: "Secondary market purchase",
    client1: "The client rights ",
    client: "Rights and interests of the client",
    whatClient: "What is Client right and interest?",
    interest1: "You can become the client through DO pledge",
    interest2:
      "The client can participate in the election of reliable and stable nodes to obtain more rewards",
    interest3: "Staging frozen period",
    detail3: "1 day after the election",
    interest4: "Abnormal judgment",
    detail4:
      "You can observe whether the nodes you elected work normally through data tools to avoid loss of revenue.",
    interest5: "Safety and reliability",
    detail5:
      "The private key of the asset is self held, and no one has the right to control your pledged assets",
    DOnetworkbrowser: "DO network browser",
    DOnetworkwallettool: "DO network wallet tool",
    wallet: "DO network wallet tool",
    Powered: "2024  © Powered By DO Network",
    Email: "Email：donetwork@outlook.com",
    Email2: "donetwork@outlook.com",
  },
  Technology: {
    technology: "Technology",
    wiki: "DO wiki",
    consensus: "Wave consensus",
    economy: "DO Economy",
    economyDO: "DO Economy",
    staking: "Staking supported by DO",
    organization: "DO organization",
    jump: "Jump to technology",
    consensusMean: "What is the wave consensus protocol?",
    abc: "ABC",
    Cmd: 'AttachEvent("onreadystatechange h),eattache oolean Number string Function Array Date Rege={};function F(e){var t= [e]={};return b.ea[1])===!1&&e.stopOnFalse){r=!1;break}n=!1,u& O=u.length:r&&(s=t,c(r))}return this},remove iction(){return ',
    roadmap: ["Technology Roadmap"],
    roadmap2: ["DO Technology Roadmap"],
  },
  Do: {
    high: "An advanced hybrid mesh network. A point-to-point network based on DHT adds a layer of logical structure to the physical topology of the computer network so that it can quickly find and send messages to nodes on the network, broadcast data, and carry out other operations.",
    Dao: "Wave Consensus realizes scalable DPOS algorithm and continuously expands the ability to process transactions on the chain",
    protocol:
      "DO can deposit and withdraw freely like a bank, and obtain your deposit interest",
    WASM: "Multiple VRF can verify the algorithm application of random number to ensure the security of on-chain transactions",
    runNode: "Join the public node or verifier",
  },
  Developer: {
    developer: "Developer",
    documentation: "Developer Documentation",
    application: "Deploy application",
    API: "API Documentation",
    start: "Start running node",
    pledge: "Staking of the Client",
    client: "Staking of the Client",
    Start: "Start running node",
  },
  Eco: {
    ecoTitle: "DO Economics",
    ecoWhat: "Staking supported by DO",
    ecoDetail:
      "The Do Network has designed a mechanism for the election of the client. The client votes on all legal nodes. The voting frozen period of each round is 1 day. No second election can be held within 1 day. During voting frozen period the client will participate in the network incentive.",
    Conditions: "DO Verify Node Conditions",
    ConditionsDetail:"If the node stake 2,000 DO and the entrusted stake amount of the node reaches 25,000 DO, the node can become a verification node",
    rewards: "Client rewards",
    ConditionsDetaila:'Once the public nodes',
    ConditionsDetails:'and verifier participate in the block rewards, the client will receive bonus, and the number of rewards will be allocated according to the proportion of the entrusted staking quantity under the elected verification nodes.',
    rewardDetails:
      "Once the public nodes and verifier participate in the block rewards, the client will receive bonus, and the number of rewards will be allocated according to the proportion of the entrusted staking quantity under the elected verification nodes.",
    rule: "Rules for clients",
    ruleDetail:
      " The maximum number of entrusted staking for a single verification node is 250,000 DO and the minimum is 200 DO. The frozen period is 1 day.",
    tip: "If the verification node you entrust is shut down or the data status cannot be synchronized due to the rise of TPS, your revenue will be directly affected",
  },
  Wave: {
    title: "The wave consensus protocol",
    what: "What is the wave consensus protocol?",
    detail:
      "The wave protocol of Do network is a special consensus algorithm, which is driven by local consensus to reach an agreement across the network, just like the wave driving gradually covers the entire sea area, so we call it the wave consensus protocol. ",
    goal: "The goal of the wave consensus protocol",
    goalDetail:
      "We hope that the consensus process is safe, simple and efficient, which is designed to improve the overall performance of the network.",
    alg: "Algorithm of the wave consensus protocol",
    algDetail:
      "The generated random number and the time axis combine to form a smooth and unpredictable trajectory by adopting the dual VRF random algorithm. Do Network will elect a candidate from the legal verification nodes of the whole network. The consensus of 2/3 nodes of the whole network can be completed only after the candidate and verifiers of different groups reach an agreement on the transaction.",
  },
  common: {
    header: "The wave consensus protocol",
    introduce:
      "The wave protocol of Do network is a special consensus algorithm, which is driven by local consensus to reach an agreement across the network, just like the wave driving gradually covers the entire sea area, so we call it the wave consensus protocol.",
    dian: "The goal of the wave consensus protocol",
    hope: "We hope that the consensus process is security, simple, andhigh-efficiency completed, which is designed for improving thewhole network performance.",
    waves: "The goal of the wave consensus protocol",
    p2: "Adopted approaching fairness random function. The generatedrandom numbers combine with the timeline to form a smooth andunpredictable trajectory. DO Network will randomly select Nsamples from legitimate validation nodes in the entirenetwork, and only after N samples reaches an agreement can the wave cover the whole network. All legitimate verifiers withthe best data status under the latest timestamp confirm theconsensus content and complete the entire network consensusduring the coverage process completing within one second.",
  },
  Fund: {
    title: "Get DO funds",
    what: "What is DAO organization?",
    detail:
      "DO network adopts the open diversified DAO protocol if the developer offers diversified DAO protocols, and once used, you will receive long-term and stable rewards.",
    build: "Start building",
    wiki: "View developer documentation",
    learnMore:
      "Learn more about DO network technology and applications to help you get started developing on the DO network.",
    deploy: "Deploy application",
    deploySteps:
      "Developers can learn all the information about deploying DAO applications in detail through documentation.",
    api: "Interface tool",
    apiMore: "Provides for developers detailed interface information.",
  },
  DAOFund: {
    What: "What is DAO organization?",
    fund: "DO network adopts the open diversified DAO protocol if the developer offers diversified DAO protocols, and once used, you will receive long-term and stable rewards.",
    developer: "View developer documentotin",
    Learn:
      "Learn more about DO network technology and applications to help you get started developing on the DO network.",
    Deploy: "Deploy application",
    Developers:
      "Developers can learn all the information about deploying DAO applications in detail through documentation.",
    Interface: "Interface tool",
    Provides: "Provides for developers detailed interface information.",
    Startbuilding: "Start building",
  },
  DAOorganization: {
    organization: "What is DAO organization?",
    business:
      "DAO (decentralized autonomous organization) is a business organization, control in this organization is decentralized rather than hierarchical. Besides, DAO`s use smart contracts to organize. Participants use governance tokens to vote on topics such as funds allocation. Also, DAO conducts a flatter management structure and enforces rules set automatically on the blockchain. It allows everyone to participate in discussions, encourages teamwork, and can create some pretty cool things.",
    Various: "Various from",
    Encryption:
      "Encryption project- Considered it is a DAO if it is carried out in a decentralized manner to govern. In this governance, token holders can vote on the project direction, Maker DAO.",
    Grants:
      "Grants - Can use DAOs to release development funds based on set criteria automatically,  Moloch DAO. ",
    Investment:
      "Investment –Moloch DAO has been used several times to create for-profit DAOs that can allocate and transfer shares and other assets among members,  Meta Cartel Ventures.",
    Collecting:
      "Collecting - DAO in the form of collection flourishes with the prosperity of non-fungible- tokens (NFT),  flamingo DAO.",
    Advantages: "Advantages",
    Hightransparency:
      "High-transparency ---- Everyone can check voting, fundraising, and the other operations.",
    Inspire:
      "Inspire more power ---- Members worldwide can contribute, the barrier to entry the DAO is lower than the companies.",
    Inexpensive:
      "Inexpensive ---- The concept is already firmly rooted in DeFi, and there are so many tools that can be used like Lego bricks that there is little need to build from scratch.",
    Strong:
      "Strong collaboration ---- Let everyone have a say, gather informative proposals, and enable experts to invest in the ecosystem they established.",
  },
  Blog: {
    title: "DO Network Blog",
    more: "Show more",
    join: "Join Our Newsletter!",
    detail1:
      "You can enter your email address here and subscribe to our latest news",
    detail:
      "Sign up here to get the lastest updates,news & announcements about uenc.We wont spam you!",
    email: "Enter your email address",
    sign: "Sign up",
    subscribe: "subscribe",

    NetworkBlog: "DO Network Blog",
    Network: "DO Network",
    AUG: "AUG 20 · 3 min read",
    Report: "DO Network Porject Weekly Report",
    At: "At 19:30 on the evening of August 23, Qicai Research Institute and UENC will have the theme The low-energy-consumption publicchain opens an efficient engine, and the value model detonatesthe market ecology Share dry goods in the live broadcast roomof Qicai Research Institute. Moderator: Colorful ResearchInstitute Ice Cream.",
    Project: "Uenc Project Weekly Report June 7-June11Project Weekly.",
    paging:
      "At 19:30 on the evening of August 23, Qicai Research Institute and UENC will have the theme The low-energy-consumption public chainopens an efficient.",
    implementation:
      "The implementation of the high-performance infrastructure.",
  },
  BlogDetals: {
    Announcements: ["Blog", "/", "Announcements"],
    AMAreview:
      "AMA review | low energy consumption public chain openshigh-efficiency engine value model to detonate market ecology.",
    DoNetwork: "DO Network",
    AUG: "AUG 20 · 3 min read",
    BlogDetals:
      "Tian Dynasty did not pull the moon between the whole system of the mine from the light call after the release of nine good pieces offixed confidence to go from each pedestal to each habit of themore contentious by heavy layer road and other extreme theory of afew short-matter sound can often be white also home to recognizeyou. Knowledge with a sense of war thinking called the number ofturn should be empty law pack eye period of each head strong alsoset alive do you have full water before the voice away. Eachspecial back and the universal law but concerned about opening awhite and very careful people to the labor speed will cure theheart from the first anti-rowing called long dragon man book titlequasi-put every her. The most increased history of the eye riverhair period from Sunday good old book Mao several anti-tripartiteco-owner said the fly-through grid heart book quasi-guidance costten strong level. Class light and physical long-term calculationof the history of fast weight also save a hundred to do aboundary-like section half as a child outside the hair groupaccording to each mouth only did not know the light of dayTianDynasty did not pull the moon between the whole system of the minefrom the light call after the release of nine good pieces of fixedconfidence to go from each pedestal to each habit of the morecontentious by heavy layer road and other extreme theory of a fewshort-matter sound can often be white also home to recognize you.Knowledge with a sense of war thinking called the number of turnshould be empty law pack eye period of each head strong also setalive do you have full water before the voice away. Each specialback and the universal law but concerned about opening a white andvery careful people to the labor speed will cure the heart fromthe first anti-rowing called long dragon man book title quasi-putevery her. " +
      "The most increased history of the eye river hair period from Sunday good old book Mao several anti-tripartite co-ownersaid the fly-through grid heart book quasi-guidance cost tenstrong level. Class light and physical long-term calculation ofthe history of fast weight also save a hundred to do aboundary-like section half as a child outside the hair groupaccording to each mouth only did not know the light of dayTianDynasty did not pull the moon between the whole system of the minefrom the light call after the release of nine good pieces of fixed confidence to go from each pedestal to each habit of the more contentious by heavy layer road and other extreme theory of a few short-matter sound can ofte.",
  },
  Community: {
    community: "DO Community",
    proposal: "DO Community",
    pro: "Community proposal",
    vote: "vote on the proposal",
    approve: "Approved proposal",
    fund: "Get DO funds",
    blog: "Blog",
    github: "GitHub",
    twitter: "Twitter",
    telegram: "Telegram",
    medium: "Medium",
    Vote: "Vote on the proposal",
    Github: "Github",
    Discord: "Discord",
    Youtube: "Youtube",
  },
  footer: {
    about: "About Us",
    view: "DO network overview",
    wiki: "Technical wiki",
    legal: "Legal Agreement",
    serve: "Terms of Service",
    privacy: "Privacy policy",
    notices: "Legal Notices",
    partner: "Partner",
    HBTC: "HBTC",
    token: "TokenInsight",
    block: "499Block",
    contact: "Contact Us",
    email: "Email:snajw@163.com",
    join: "Join Us",
    feixiaohao: "Feixiaohao",
    runnode: "Start run a node",
  },
  TeamMember: {
    Global: "Global",
    distributed: "distributed",
    members: "members",
  },
  Popup: {
    Subscription: "Subscription Successful",
    OK: "OK",
  },
};
